var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgM = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 28",
  viewBox: "0 0 203.503 173.681"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "M_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h203.503v173.681H0z",
  "data-name": "Rectangle 28",
  style: {
    fill: "none"
  }
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 27",
  style: {
    clipPath: "url(#M_svg__a)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M65.268 32.634A32.634 32.634 0 1 1 32.634 0a32.634 32.634 0 0 1 32.634 32.634",
  "data-name": "Path 52"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M203.5 32.6a32.33 32.33 0 0 1-13.952 26.65 31.9 31.9 0 0 1-18.7 6.008 32.67 32.67 0 0 1-32.66-32.658 31.2 31.2 0 0 1 1.744-10.465A32.664 32.664 0 0 1 203.5 32.6",
  "data-name": "Path 53"
})), /*#__PURE__*/React.createElement("path", {
  d: "M87.586 171.181c-36.323 0-63.442-13.025-76.363-36.676C-.7 112.68 1.183 83.643 16.021 60.532a65 65 0 0 1 4.152-5.75l.079-.1c.485-.647.971-1.253 1.457-1.86s.985-1.233 1.478-1.886a91.7 91.7 0 0 1 33.852-23.61l.46-.19.294-.293q.789-.291 1.585-.594c1.58-.6 3.212-1.215 4.851-1.652l.086-.023.085-.029A112 112 0 0 1 78.591 20.8a99 99 0 0 1 17.995-1.783h10.333a101.9 101.9 0 0 1 32.2 5.536l.156.047c1.639.437 3.273 1.055 4.853 1.652.685.26 1.366.517 2.047.761a96.4 96.4 0 0 1 34.143 23.925c.493.653.987 1.269 1.48 1.886s.97 1.213 1.457 1.86l.078.1a65 65 0 0 1 4.164 5.772 79 79 0 0 1 12.59 42.46c0 29.8-18.97 63.225-72.207 67.676-3.69.322-7.822.491-11.959.491z",
  "data-name": "Path 54",
  style: {
    fill: "#fff"
  }
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M106.918 21.514a99.4 99.4 0 0 1 31.4 5.4l.157.054.159.043a48 48 0 0 1 4.612 1.575c.675.255 1.347.509 2.017.75a93.9 93.9 0 0 1 33.125 23.185c.5.658.986 1.267 1.458 1.858.491.613.955 1.193 1.409 1.8l.077.1.082.1a63 63 0 0 1 3.986 5.529 76.54 76.54 0 0 1 12.189 41.1c0 28.686-18.368 60.875-69.934 65.187-3.613.313-7.67.481-11.733.481H87.585c-35.366 0-61.707-12.564-74.169-35.376C1.931 112.283 3.771 84.265 18.1 61.918a63 63 0 0 1 3.991-5.536l.082-.1.077-.1c.454-.6.918-1.185 1.408-1.8.473-.591.96-1.2 1.459-1.858a89.2 89.2 0 0 1 32.875-22.887l.923-.38.258-.26q.543-.202 1.087-.408a48 48 0 0 1 4.613-1.575l.173-.047.17-.058a110 110 0 0 1 13.839-3.655 96.4 96.4 0 0 1 17.53-1.74zm0-5H96.585a101 101 0 0 0-18.5 1.835 116 116 0 0 0-14.5 3.833c-2.5.666-4.834 1.666-7.167 2.5l-.333.332a94.8 94.8 0 0 0-34.834 24.334c-1 1.332-2 2.5-3 3.833a68 68 0 0 0-4.333 6c-29 45.167-11.833 114.5 73.667 114.5h28.333c4.166 0 8.333-.166 12.167-.5 51.833-4.334 74.5-36.5 74.5-70.168a82 82 0 0 0-13-43.833 68 68 0 0 0-4.334-6c-1-1.334-2-2.5-3-3.833a98.9 98.9 0 0 0-35.168-24.666c-2.332-.834-4.666-1.834-7.166-2.5a104 104 0 0 0-33-5.668",
  "data-name": "Path 55"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M99.489 74.288c0 14.843-13.84 29.694-31.763 31.123C48.79 106.92 37.039 92.762 41.733 76.3c4.037-14.159 18.99-24.262 33.311-24.262 13.728 0 24.445 9.318 24.445 22.247",
  "data-name": "Path 56"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M106.076 74.288c0 14.843 13.84 29.694 31.763 31.123 18.936 1.509 30.687-12.649 25.993-29.108-4.037-14.159-18.99-24.262-33.311-24.262-13.728 0-24.445 9.318-24.445 22.247",
  "data-name": "Path 57"
})), /*#__PURE__*/React.createElement("path", {
  d: "M86.336 84.966a2.72 2.72 0 0 1-2.724-2.724 9.542 9.542 0 0 0-19.084 0 2.724 2.724 0 1 1-5.448 0 14.99 14.99 0 0 1 29.98 0 2.72 2.72 0 0 1-2.724 2.724",
  "data-name": "Path 58",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.5 84.966a2.72 2.72 0 0 1-2.724-2.724 9.545 9.545 0 0 0-19.09 0 2.724 2.724 0 1 1-5.448 0 14.993 14.993 0 0 1 29.986 0 2.72 2.72 0 0 1-2.724 2.724",
  "data-name": "Path 59",
  style: {
    fill: "#fff"
  }
}), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m92.454 119.183-2.868-3.683a6.515 6.515 0 0 1 5.141-10.517h18.854a6.515 6.515 0 0 1 5.14 10.517l-2.868 3.684a14.827 14.827 0 0 1-23.4 0",
  "data-name": "Path 60"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M91.9 143.714a15.01 15.01 0 0 1-15-14.993 2.724 2.724 0 0 1 5.448 0 9.542 9.542 0 1 0 19.084 0 2.725 2.725 0 0 1 5.449 0A15.01 15.01 0 0 1 91.9 143.714",
  "data-name": "Path 61"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M116.415 143.714a15.01 15.01 0 0 1-14.993-14.993 2.724 2.724 0 0 1 5.448 0 9.542 9.542 0 1 0 19.084 0 2.724 2.724 0 0 1 5.449 0 15.01 15.01 0 0 1-14.988 14.993",
  "data-name": "Path 62"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M104.146 131.972a2.72 2.72 0 0 1-2.724-2.724v-5.358a2.724 2.724 0 0 1 5.448 0v5.358a2.72 2.72 0 0 1-2.724 2.724",
  "data-name": "Path 63"
}))));
export default SvgM;